import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import LoadingState from '../../loading-state';
import Carousel from '../complaint-detail/Carousel';
import NoImage from '../combined-shape.svg';
import Angry from '../service-feedback/Smiley_angry.svg';
import Happy from '../service-feedback/Smiley_happy.svg';
import Love from '../service-feedback/Smiley_love.svg';
import Normal from '../service-feedback/Smiley_normal.svg';
import Sad from '../service-feedback/Smiley_sad.svg';
import { FeedbackObj } from '../../../globs/constants';
import gaPush from '../../../globs/utils/google-analytics';
import config from '../../../globs/config';

class ComplaintDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      showFeedBackForm: false,
      carouselData: [],
      complaint:{},
    };
  }

  componentDidMount() {
    this.fetchDetail();
  }

  componentDidUpdate(prevProps, prevState) {
    // our comment
    // Only update when API status changes from PENDING to complete/rejected
    // Prevent infinite loops in React 19
    if (prevProps.detailLoadStatus === 'PENDING' &&
      (this.props.detailLoadStatus === '' || this.props.detailLoadStatus === 'REJECTED')) {
      // Only update if showLoader needs to change
      if (this.state.showLoader !== false) {
        this.setState({
          showLoader: false,
        }, () => {
          this.showSelectedEmoji();
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.complaintDetailReset();
  }

  fetchDetail = () => {
    const { props } = this;
    const soID = this.props.user.id;
    // const id = props.location.pathname.split('/').pop();
    const id = this.props.match.params.complaintId
   const customerId= this.props.match.params.customerId

    // const url = `${props.user._links.complaints.href}/${id}`;
    const url = `${config.apiContextPath}/sales_officers/${soID}/businesses/${customerId}/complaints/${id}`;
    props.dataLoad({
      key: 'complaintDetail',
      url,
    });


  }


  handleImageClick = (imageDataId, data) => {
    // console.log('handleImageClick ===>', data);
    if (imageDataId) {
      this.setState({
        imageDataId,
        carouselData: data,
      });
    }
  }

  handleCarouselClose = () => {
    this.setState({
      imageDataId: null,
    });
  }

  showSelectedEmoji = () => {
    // console.log('vlue ==>', value);

    const selectEmojy = Object.keys(FeedbackObj).filter(item =>
      FeedbackObj[item].value === this.props.complaint.rating);
    // console.log('selectEmojy', selectEmojy);

    if (selectEmojy.length > 0) {
      import(`../service-feedback/Smiley_${selectEmojy}.svg`).then((img) => {
        this.setState({
          selectedfeebbackImage: img,
        });
      });
    }
  }

  showFeedBackForm = () => {
    this.setState({
      showFeedBackForm: !this.state.showFeedBackForm,
    });
  }

  fireGaEvent = (act, action, labelIn) => {
    const label = `${labelIn}`;
    gaPush('event', {
      category: act,
      action,
      label,
    });
  };

  // gaEvents = () => {
  //   this.fireGaEvent('Contact Us', 'Back ', 'To List from Detail');
  // }

  // handleImageGaEvents = (id, file) => {
  //   // const currentImage = file.find(item => item.id === id);
  //   // const filename = JSON.parse(currentImage.file_url_data).metadata.filename;
  //   // const fileExtention = file && filename.substring(filename.lastIndexOf('.') + 1);
  // }

  render() {
    // const { props, state: { showLoader } } = this;
    const { props, state } = this;
    // console.log('propsssss=>', props.complaint);
    let showCategory = '';
    if (props.complaint && props.complaint.complaint_sub_category) {

      showCategory = <span> {props.complaint.complaint_category} <i className="icon-arrow_right" /> {props.complaint.complaint_sub_category} </span>;
    } else if (props.complaint.complaint_category) {
      showCategory = props.complaint.complaint_category;
    }
    const selectEmojy = Object.keys(FeedbackObj).filter(item => FeedbackObj[item].value ===
      props.complaint.rating);
    return (
      <div className="lr-main lr-main-home zambia-dashboard">
        <div className="contact-us">
          <div className="lr-make-sale lr-overlay">
            <div className="lr-overlay__header">
              <div className="lr-overlay__header-title"><button type="button" className="lr-overlay__header-back-button">
                <i
                  className="icon-back"
                  onClick={() => {
                    this.props.history.goBack();
                    // this.gaEvents();
                  }}
                />
              </button><span>{props.complaint.complaint_number}</span></div>
            </div>
            {
              this.state.showLoader ? <LoadingState />
              :
              <div className="lr-overlay__body complaint-detail-page">
                <div className="lr-order-list">
                  <div className="complaint-detail-container">
                    <span className="complaint-list-item-label">{showCategory}</span>
                    {
                      props.complaint.reference_number &&
                      <div className="reference-number">
                        <span className="reference-number-label">Reference: </span>
                        <span className="reference-number-value">{props.complaint.reference_number}</span>
                      </div>
                    }
                    <div className="complaint-date-id">
                      <span className="list-item-date-id">
                        <span>{moment(props.complaint.created_at).format('DD.MM.YYYY | HH:mm')}</span>
                      </span>
                      <button style={{ background: `${props.complaint.status_color ? props.complaint.status_color : ''}` }} className={`${(props.complaint.complaint_status).toLowerCase()}-button`}>
<span>{props.complaint.complaint_status}</span>
                      {/* <FormattedMessage id={`Status.${props.complaint.complaint_status}`} /> */}
                      </button>
                    </div>
                    <div className="complaint-info">
                      <div className="pending-note">
                        <i className="note-icon">i</i>
                        <span>A customer / sales representative will get in touch with you to address your concern within 24 hours</span>
                        {/* <FormattedMessage id="Representative.get.in.touch" /> */}
                      </div>
                      <p className="description-heading">
                        <span>Description</span>
                        {/* <FormattedMessage id="Description.text" /> */}
                        </p>
                      <p className="description-text-detail">{props.complaint.description}</p>
                      <p className="pictures-uploaded">
                        <span>Attachments Uploaded</span>
                        {/* <FormattedMessage id="Pictures.Uploaded" /> */}
                         ({props.complaint.complaint_files && props.complaint.complaint_files.filter(x => x.principle_type === 'Business').length})</p>
                      {
                        props.complaint.complaint_files &&
                        props.complaint.complaint_files.map((file) => {
                          if (file.principle_type !== 'Business') {
                            return '';
                          }
                          const imagePath = file.file_url_data.file_type;
                          const fileName = file.file_url_data.metadata.filename;
                          return (
                            <div key={file.id}>
                              <div className="complaint-multiple-uploads" key={fileName} onClick={() => { this.handleImageClick(file.id, props.complaint.complaint_files); this.fireGaEvent('ContactUs', 'AttachmentClicked', `${props.complaint.complaint_number}`); }}>
                                <div>
                                  {(imagePath !== 'pdf' && imagePath !== 'doc' && imagePath !== 'docx' && imagePath !== 'xls' && imagePath !== 'xlsx') ?
                                    <img src={file.file_url} /> :
                                    <img className="view-img" src={NoImage} />
                                  }
                                </div>
                                <div>
                                  {/* <p className="file-from-upload">{fileName}</p> */}
                                  <p>
                                    {/* <FormattedMessage id="UploadedOn" /> */}
                                  <span>Uploaded On</span><span>{moment(props.complaint.created_at).format('DD.MM.YYYY')}</span></p>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      }
                      {
                        props.complaint.comment &&
                        <React.Fragment>
                          <p className="lafarge-comment-label">
                            <span>Comments from Lafarge</span>
                            {/* <FormattedMessage id="Comments.from.Lafarge.text" /> */}
                            </p>
                          <p className="lafarge-comment-text"><span className="lafarge-comment-date">{moment(props.complaint.comment_created_at).format('DD.MM.YYYY')} - </span>{props.complaint.comment}</p>
                        </React.Fragment>
                      }
                      {
                        props.complaint.complaint_files &&
                        props.complaint.complaint_files.map((file) => {
                          if (file.principle_type === 'Business') {
                            return '';
                          }
                          const imagePath = file.file_url_data.file_type;
                          const fileName =file.file_url_data.metadata.filename;
                          return (
                            <div key={fileName}>
                              <div className="complaint-multiple-uploads" key={fileName} onClick={() => { this.handleImageClick(file.id, props.complaint.complaint_files); }}>
                                <div>
                                  { (imagePath !== 'pdf' && imagePath !== 'doc' && imagePath !== 'docx' && imagePath !== 'xls' && imagePath !== 'xlsx') ?
                                    <img src={file.file_url} /> :
                                    <img className="view-img" src={NoImage} />
                                  }
                                </div>
                                <div>
                                  <p className="file-from-lafarge">{fileName}</p>
                                  <p>
                                    <span>Uploaded On</span>
                                    {/* <FormattedMessage id="UploadedOn" /> */}
                                  <span>{moment(props.complaint.created_at).format('DD.MM.YYYY')}</span></p>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      }
                      {/* {
                        !props.complaint.feedback &&
                        <button className="rate-service-button"
                        onClick={this.showFeedBackForm}>Rate our service</button>
                      } */}
                      {
                        props.complaint.rating &&
                        <div className="feedback">
                          <p className="your-feedback-label">Your Feedback</p>
                          <div className="selected-emo">
                            <img src={this.state.selectedfeebbackImage} />
                            <p>
                              {/* <FormattedMessage id={`Complaint.FeedbackMsg.${selectEmojy}`} /> */}
                              {props.complaint.rating === 1 && <span>It's not useful</span>}
                              {props.complaint.rating === 2 && <span>I don't like it</span>}
                              {props.complaint.rating === 3 && <span>It's good</span>}
                              {props.complaint.rating === 4 && <span>I like it</span>}
                              {props.complaint.rating === 5 && <span>i love it!</span>}
                               </p>
                          </div>
                          <div className="all-emo">
                            <img src={Angry} className={props.complaint.rating === 1 ? 'active' : ''} />
                            <img src={Sad} className={props.complaint.rating === 2 ? 'active' : ''} />
                            <img src={Normal} className={props.complaint.rating === 3 ? 'active' : ''} />
                            <img src={Happy} className={props.complaint.rating === 4 ? 'active' : ''} />
                            <img src={Love} className={props.complaint.rating === 5 ? 'active' : ''} />
                          </div>
                            {
                              props.complaint.feedback &&
                              <React.Fragment>
                                <p className="feedback-comment">Feedback Comment</p>
                                <span>{props.complaint.feedback}</span>
                              </React.Fragment>
                            }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          {this.state.imageDataId &&
            <Carousel
              createat={props.complaint.created_at}
              data={this.state.carouselData}
              imageDataId={this.state.imageDataId}
              closePop={this.handleCarouselClose}
              user={props.user}
              customerId={this.props.match.params.customerId}
            />
          }
        </div>
      </div>
    );
  }
}

ComplaintDetail.propTypes = {
  dataLoad: PropTypes.func.isRequired,
  // detailLoadStatus: PropTypes.string.isRequired,
  complaint: PropTypes.shape({
    rating: PropTypes.number,
    complaint_number: PropTypes.string,
  }).isRequired,
  complaintDetailReset: PropTypes.func.isRequired,
};

export default ComplaintDetail;
